<template>
  <div>
    <h5 v-if="!inline">
      Habilitações para Lotes e Direito de Preferência
    </h5>

    <div class="filters row font-11 justify-between">
      <div class="col text-grey-7" style="max-width: 170px; line-height: 20px">
        <!--{{table.serverPagination.rowsNumber}} lote{{table.serverPagination.rowsNumber > 1 ? 's' : ''}}-->
        {{ table.serverPagination.rowsNumber }} habilitado{{ Number(table.serverPagination.rowsNumber) > 1 ? 's' : '' }}
        <u-btn @click="load" icon="refresh" round rounded flat size="xs" :loading="table.loading"/>
      </div>
      <div class="col text-grey-7" style="max-width: 170px; line-height: 20px">
        <u-btn @click="exportar('excel')" flat icon="file-excel" icon-type="fa" icon-style="light" title="Exportar" label="Exportar" size="sm" no-caps />
      </div>
      <div class="col m-l-lg" style="line-height: 20px; max-width: 500px">
        <div class="row">
          <div class="col">
            <!--            <erp-checkbox class="flex no-wrap items-center m-r" v-model="table.filters.semCobranca">
                          <label class="no-select text-nowrap font-bold">
                            <span class="m-l-xs text-nowrap">Aprovados</span>
                          </label>
                        </erp-checkbox>

                        <erp-checkbox class="flex no-wrap items-center m-r" v-model="table.filters.comCobranca">
                          <label class="no-select text-nowrap font-bold">
                            <span class="m-l-xs text-nowrap">Reprovados</span>
                          </label>
                        </erp-checkbox>

                        <erp-checkbox class="flex no-wrap items-center m-r" v-model="table.filters.comCobranca">
                          <label class="no-select text-nowrap font-bold">
                            <span class="m-l-xs text-nowrap">Em análise</span>
                          </label>
                        </erp-checkbox>
                        -->

          </div>
        </div>
      </div>
      <div class="col" style="min-width: 300px;">
        <erp-s-field
            class="font-10 m-r-md"
            view="lr"
            label="Adicionar arrematante:"
        >
          <arrematante-input v-model="idArrematante" :finded-data-obj="cache.arrematanteSelected"
                             @updateSelected="(data) => {cache.arrematanteSelected = data; confirmaAdicionarHabilitado()}" />
        </erp-s-field>
      </div>

      <div class="col" style="">
        <erp-s-field
            class="font-10"
            view="lr"
            label="Buscar:"
        >
          <helper-input-btn>
            <erp-input simple-border v-model="table.filters.pesquisa"/>
            <a class="m-l-xs text-black">IR</a>
          </helper-input-btn>
        </erp-s-field>
      </div>
      <div class="col m-l m-b-n" style="max-width: 110px; text-align: right">
        <i class="fa fa-cog" style="cursor: pointer" @click="listOptions"></i>
      </div>
    </div>
    <div class="erp-list no-pad">
      <u-table
          ref="table"
          color="primary"
          :data="filteredServerData"
          :columns="table.columns"
          :visible-columns="visibledColumns"
          :filter="table.busca"
          row-key="id"
          :pagination.sync="table.serverPagination"
          @request="request"
          selection="multiple"
          :selected.sync="table.selected"
          :loading="table.loading"
          class="erp-table"
          :rows-per-page-options="[100, 300]"
      >
        <!--<template slot="top-right" slot-scope="props">
        </template>-->
        <u-tr slot="header" slot-scope="props">
          <u-th auto-width>
            <u-checkbox
                v-model="props.selected"
                :indeterminate="props.partialSelected"
                size="sm"
            />
          </u-th>
          <u-th v-for="col in props.cols" :key="col.name" :props="props">
            {{ col.label }}
          </u-th>
        </u-tr>

        <u-tr @dblclick.native="arrematanteWindow(props.row.arrematante.id)" slot="body" slot-scope="props"
              :props="props">
          <u-td auto-width>
            <u-checkbox color="primary" v-model="props.selected" size="xs"/>
          </u-td>
          <u-td key="lote" :props="props">
            <div>{{ props.row.lote.numeroString || props.row.lote.numero }}</div>
          </u-td>
          <u-td key="direitoPreferencia" :props="props">
            <div v-if="!props.row.direitoPreferencia"></div>
            <div class="direitoPreferenciaLbl" v-else-if="props.row.direitoPreferencia === 1">Solicitado</div>
            <div class="direitoPreferenciaLbl reprovado" v-else-if="props.row.direitoPreferencia === 99">Reprovado</div>
            <div class="direitoPreferenciaLbl aprovado" v-else-if="props.row.direitoPreferencia === 100">Aprovado</div>
          </u-td>
          <u-td key="apelido" :props="props">
            <div>{{ props.row.arrematante.apelido }}</div>
          </u-td>
          <u-td key="idArrematante" :props="props">
            <div>{{props.row.arrematante.id}}</div>
          </u-td>
          <u-td key="nome" :props="props">
            {{ props.row.arrematante.pessoa.name }}
          </u-td>
          <u-td key="data"
                :props="props">
            {{ props.row.createdAt.date|formatDate }}
          </u-td>
          <u-td key="status"
                :props="props">
            <span v-if="props.row.status === 1" class="text-positive">Aprovado</span>
            <span v-else-if="props.row.status === 0" class="text-purple">Em análise</span>
            <span v-else class="text-negative">Bloqueado*<u-tooltip>Se a habilitação por lote estiver ativa no leilão, este arrematante não poderá efetuar lances neste lote</u-tooltip></span>
          </u-td>
          <u-td class="text-center" key="options" :props="props">
            <e-btn-table-options>
              <menu-options>
                <default-list-menu
                    @aprovar="aprovar(props.row)"
                    @aprovarDp="aprovar(props.row, 'dp')"
                    @reprovar="reprovar(props.row)"
                    @excluir="excluir(props.row)"
                    :habilitacao="props.row"/>
              </menu-options>
            </e-btn-table-options>
          </u-td>
          <!--          <context-menu-lote-item
                        @abrir="abrir(props.row)"
                        @abrirBem="abrirBem(props.row.bem.id)"
                        @removerLote="remover(props.row)"
                        :leilao="props.row" />-->
        </u-tr>
      </u-table>

      <!--          v-if="table.selected.length > 0"-->
    </div>
  </div>
</template>

<script>
import {UCheckbox, UTable, UTd, UTh, UTr, LocalStorage, UTooltip} from 'uloc-vue'
import {EBtnTableOptions, /*ErpCheckbox, */ErpSField, ErpInput, HelperInputBtn} from 'uloc-vue-plugin-erp'
import {list, aprovar, reprovar, habilitar, excluir} from '@/domain/arrematante/services/arrematante-habilitacao-lote'
import MenuOptions from '../../../layout/context-menu/context-window-options'
import DefaultListMenu from './context/list-menu-lote'
//import ContextMenuLoteItem from '../context/list-context-lote'
import arrematanteWindow from '../../../arrematante/windows/arrematante'
import AlteracaoStatusLoteMixin from '../include/AlteracaoStatusLoteMixin'
import listOptions from '../../windows/listOptions'
import DefaultMixin from '@/components/leiloes/mixin'
import ArrematanteInput from '../../../arrematante/helpers/input/ArrematanteInput'
import {donwloadFile} from "@/utils/downloadFile"

//let listStorage = LocalStorage.get.item('leilao.habilitacoesLotes.list')
//if (!listStorage) {
  let listStorage = [
    {label: 'Lote', name: 'lote', active: true, sortable: true, ordering: 1},
    {label: 'Direito de Preferência', name: 'direitoPreferencia', active: true, sortable: true, ordering: 1},
    {label: 'Apelido', name: 'apelido', active: true, sortable: true, ordering: 1},
    {label: 'ID Arrematante', name: 'idArrematante', active: true, sortable: true, ordering: 1},
    {label: 'Nome', name: 'nome', active: true, sortable: true, ordering: 1},
    {label: 'Data de habilitação', name: 'data', active: true, sortable: true, ordering: 1},
    {label: 'Situação', name: 'status', active: true, sortable: true, ordering: 1}
  ];
  LocalStorage.set('leilao.habilitacoesLotes.list', listStorage)
//}

let filters = {
  semCobranca: true,
  comCobranca: true,
  pesquisa: null
}

export default {
  name: 'ListaHabilitacoesLotes',
  mixins: [AlteracaoStatusLoteMixin, DefaultMixin],
  inject: ['page', 'erplayout'],
  props: {
    inline: {type: Boolean, default: false},
    lote: {required: false}
  },
  data() {
    if (this.inline) {
      listStorage = listStorage.map(l => {
        if (['idArrematante'].includes(l.name)) {
          l.active = false
        }
        return l
      })
    }
    return {
      leilao: this.page.leilao,
      listStorage: listStorage,
      table: {
        busca: '',
        serverData: [],
        serverPagination: {
          page: 1,
          rowsNumber: 0, // specifying this determines pagination is server-side
          rowsPerPage: 100
        },
        columns: listStorage.map(o => {
          return {
            ...o,
            field: o.name,
            required: o.required || null,
            align: 'left'
          }
        }).concat([
          {
            name: 'options',
            required: true,
            label: '',
            field: 'options',
            sortable: false
          }
        ]),
        filter: '',
        filters: JSON.parse(JSON.stringify(filters)),
        selected: [],
        loading: false
      },
      idArrematante: null,
      cache: {
        arrematanteSelected: null,
      }
    }
  },
  components: {
    ArrematanteInput,
    // ContextMenuLoteItem,
    MenuOptions,
    UTable,
    UTh,
    UTr,
    UTd,
    UCheckbox,
    EBtnTableOptions,
    DefaultListMenu,
    // ErpCheckbox,
    ErpSField,
    ErpInput,
    HelperInputBtn,
    UTooltip
  },
  mounted() {
    this.page && this.page.setActive && this.page.setActive('hbl')
    console.log(this.leilao)
    this.load()
  },
  computed: {
    visibledColumns() {
      return this.listStorage.filter(item => {
        /*if (item.name === 'imagem') {
          return !this.table.filters.ocultarFotos
        }*/
        return item.active
      }).map(item => item.name)
    },
    filteredServerData() {
      let data = this.table.serverData.slice()

      let busca = this.table.filters.pesquisa
      if (busca && String(busca).length > 0) {
        console.log(busca)
        data = data.filter(lt => {
          return String(lt.arrematante.apelido).toLowerCase().indexOf(busca) > -1
              || String(lt.arrematante.pessoa.name).toLowerCase().indexOf(busca) > -1
        })
      }
      return data
      /*return this.table.serverData.slice().sort(function (a, b) {
        a = Number(a['numero'])
        b = Number(b['numero'])
        return (a === b ? 0 : a > b ? 1 : -1) * 1 // -1 = desc, 1 = asc
      })*/
    }
  },
  methods: {
    load() {
      this.request({
        pagination: this.table.serverPagination,
        filter: this.table.busca
      })
    },
    exportar () {
      this.request({
        pagination: this.table.serverPagination,
        filter: this.table.busca
      }, true)
    },
    request({pagination, filter}, exportar = false) {
      this.table.loading = true
      this.table.selected = []
      let _filter = this.filtros
      let filtros = encodeURI(`&sortBy=${pagination.sortBy}&descending=${pagination.descending}&search=${filter}&leilao=${this.leilao.id}`)
      if (exportar) {
        filtros += '&export=true'
      }
      if (this.lote && this.lote.id) {
        filtros += '&lote=' + this.lote.id
      }

      list(pagination.rowsPerPage, pagination.page, filtros, exportar)
          .then((response) => {
            if (exportar) {
              donwloadFile(response)
              this.table.loading = false
              return
            }
            this.table.serverPagination = pagination
            this.table.serverPagination.rowsNumber = response.data.total
            this.table.serverData = response.data.result || []

            this.table.loading = false
            this.loadedData()
          })
          .catch(error => {
            this.loading = false
          })
    },
    listOptions: listOptions,
    loadedData() {
      this.$emit('loaded', this.table.serverData)
    },
    arrematanteWindow: arrematanteWindow,
    aprovar(habilitacao, dp = false) {
      let extra = []
      if (dp) {
        extra.push('comDireitoPreferencia=1')
      }
      aprovar(habilitacao.id, extra.join('&'))
          .then(({data}) => {
            // this.load()
            this.$uloc.notify({color: 'positive', message: habilitacao.arrematante.apelido + ' habilitado com sucesso'})
            habilitacao.status = data.status
            habilitacao.direitoPreferencia = data.direitoPreferencia
          })
          .catch(error => {
            this.alertApiError(error)
          })
    },
    reprovar(habilitacao) {
      reprovar(habilitacao.id)
          .then(({data}) => {
            // this.load()
            this.$uloc.notify({
              color: 'negative',
              message: habilitacao.arrematante.apelido + ' teve a habilitação bloqueada.'
            })
            habilitacao.status = data.status
            habilitacao.direitoPreferencia = data.direitoPreferencia
          })
          .catch(error => {
            this.alertApiError(error)
          })
    },
    excluir(habilitacao) {
      this.confirmarExclusao('Tem certeza que deseja excluir este registro? ', 'Sim')
          .then(() => {
            excluir(habilitacao.id)
                .then(({data}) => {
                  // this.load()
                  this.$uloc.notify({
                    color: 'negative',
                    message: habilitacao.arrematante.apelido + ' teve a habilitação excluída.'
                  })
                  this.load()
                })
                .catch(error => {
                  this.alertApiError(error)
                })
          }).catch(() => {})
    },
    adicionarHabilitado(lote, direitoPreferencia) {
      habilitar(this.idArrematante, this.leilao.id, lote, direitoPreferencia)
          .then(({data}) => {
            this.load()
            this.$uloc.notify({color: 'positive', message: 'Arrematante habilitado com sucesso!'})
          })
          .catch(error => {
            this.alertApiError(error)
          })
    },
    confirmaAdicionarHabilitado () {
      let loteNum = ''
      if (this.lote && this.lote.numero) {
        loteNum = this.lote.numeroString || this.lote.numero
      }
      this.$uloc.dialog({
        title: 'Atenção',
        message: `Qual o número do lote?`,
        prompt: {
          model: loteNum,
          type: 'text' // optional
        },
        cancel: true,
        color: 'secondary'
      }).then(lote => {
        this.$uloc.dialog({
          title: 'Atenção',
          message: `Habilitar direito de preferência?`,
          options: {
            type: 'radio',
            model: '0',
            items: [
              {label: 'Sim', value: '1', color: 'primary'},
              {label: 'Não', value: '0'}
            ]
          },
          cancel: true,
          color: 'secondary'
        }).then(direitoPreferencia => {
          this.$uloc.notify({color: 'warning', message: 'Habilitando arrematante, aguarde'})
          this.adicionarHabilitado(lote, direitoPreferencia)
        }).catch(() => {
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="stylus">
.status-envio {
  .nao-enviado {
    background-color rgb(239, 239, 239)
  }
}
  .direitoPreferenciaLbl {
    display inline-flex
    padding 5px
    font-weight bold
    background blueviolet
    color #FFFFFF
    &.aprovado {
      background greenyellow
      color #000000
    }
    &.reprovado {
      background red
      color #FFFFFF
    }
  }
</style>
